<app-topheader></app-topheader>
<div class="scrollingcontainer ">

    <div class="container">
        <app-fancy-page-title topTitle="ENTERTAINMENT AND ENRICHMENT"></app-fancy-page-title>


        <!-- <app-goldbar></app-goldbar>
        <app-current-date></app-current-date> -->
        <div class="tenpxtop"></div>
        
        <div class="row">
            <div class="col-1"></div>
            <div class="col-10 goldbar d-flex justify-content-center">
                ______________________________________________________________________________
            </div>
          </div>

        <app-entertainment-times></app-entertainment-times>
        <div class="tenpxtop"></div>
        <div class="row">
            <!-- <div class="col-2">
                <button class="btn btn-outline-secondary">Back</button>
            </div> -->
            <div class="col-7">

            </div>
            <div class="col-4">
                <!-- <button class="btn btn-outline-secondary" [routerLink]="['/mealdescription']">View Menu</button> -->
            </div>
        </div>
    </div>
</div>
<app-bottommenu></app-bottommenu>